export const testimonials = [
  {
    id: 1,
    name: "Ron Smith",
    role: "CEO",
    company: "Northbridge Analytics",
    rating: 5,
    quote:
      "With Conectify's appointment-setting services, we closed thirteen major deals for our digital marketing agency in a single quarter.",
  },
  {
    id: 2,
    name: "Elena Marsh",
    role: "VP Marketing",
    company: "Orbital Supply Co.",
    rating: 5,
    quote:
      "The data accuracy alone paid for the engagement. Our reply rates roughly doubled within the first month.",
  },
  {
    id: 3,
    name: "Daniel Ortiz",
    role: "Head of Growth",
    company: "Verdant Health Group",
    rating: 4,
    quote:
      "Conectify's team treats our pipeline like it's their own. Reporting is clear and the targeting keeps improving.",
  },
  {
    id: 4,
    name: "Priya Nandan",
    role: "Founder",
    company: "Lumen Recruiting",
    rating: 5,
    quote:
      "Recruitment support from Conectify shortened our average time-to-hire by weeks, not days.",
  },
];
